import Vue from 'vue';
import {HTTP} from '@/utils/httpCommonUtil';
import VueSimpleSpinner from 'vue-simple-spinner';
import { BallPulseLoader } from 'vue-loaders';
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';

export default Vue.component('facility-financial-card', {
  name: 'FacilityFinancialCard',
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      saving: false,
      financialInfo: null,
      errors: { quickbooksNameErrorMessage: '', quickbooksClassErrorMessage: ''}
    };
  },
  computed: {
    facilityId (): string {
      return this.$route.params.facilityId;
    }
  },
  methods: {
    async expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.loadData();
      }
    },
    async loadData() {
      let showLoadingSpinnerTimeout = setTimeout(() => {
        this.loadingInitialData = true;
      }, 0);
      try {
        const response = await HTTP.get(`/api/facilities/${this.facilityId}/financial`);
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error fetching Financial Info.");
        }
        const results = response.data.data;
        if (results.length > 0) {
          this.financialInfo = results[0];
        } else {
          this.financialInfo = null;
        }
      } catch (err) {
        clearTimeout(showLoadingSpinnerTimeout);
        this.loadingInitialData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching Financial Information..'
        });
      }
    },
    async save() {
      try {
        this.errors.quickbooksNameErrorMessage = '';
        this.errors.quickbooksClassErrorMessage = '';
        this.saving = true;
        await HTTP.put(`/api/facilities/${this.facilityId}/financial`, this.financialInfo);
        this.saving = false;
      } catch (err) {
        this.saving = false;
        this.errors.quickbooksNameErrorMessage = getRestParamErrorMessage(err, 'quickbooksName');
        this.errors.quickbooksClassErrorMessage = getRestParamErrorMessage(err, 'quickbooksClass');
        if (!this.errors.quickbooksNameErrorMessage && !this.errors.quickbooksClassErrorMessage) {
          let generalError = getRestResponseErrorMessage(err);
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Saving',
            text: generalError ? generalError : 'An error occurred saving Financial information.',
          });
        }
      }
    },
    cancel() {
      this.cardExpanded = false;
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/facility/cards/financial/FacilityFinancialCard.ts